<a
    *appHasPermissionId="permissionList.strategicGoal; else justNameTemplateRef"
    [routerLink]="['', 'system-list', 'strategic-goal', 'detail', item.id]"
>
    {{ item.name }}
</a>
<ng-template #justNameTemplateRef>
    {{ item.name }}
</ng-template>
